import {API} from './api'
import {METHOD, request} from '@/utils/request'

/**
 * 左侧
 * @param {*} params 
 * @returns 
 */
export  function listAll(params) {
    return request(API+'/itemTemplete/getItemOrgList',
       METHOD.GET,
        params
    )
}

/**
 * 根据事项学院查询一条模板信息
 * @param {*} params 
 * @returns 
 */
export  function getOne(params) {
    return request(API+'/itemTemplete/getByItemIdAndOrgId',
    METHOD.GET,
     params
 )
}

/**
 * 新增
 * @param {*} data 
 * @returns 
 */
export function save(data) {
    return request(API+'/itemTemplete/insert', 
        METHOD.POST,
        data
    )
}

/**
 * 更新
 * TODO 存在问题
 * @param {*} data 
 * @returns 
 */
export function update(data) {
    return request(API+'/itemTemplete/update', 
        METHOD.POST,
        data
    )
}
